const Loader = () => {
    return (
        <div className="centered-loader">
            <div class="loader"></div>
        </div>
    )
}

export default Loader